import { c as _c } from "react/compiler-runtime";
import { Tooltip } from "react-tooltip";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { TOOLTIP_STYLES } from "@/helpers/tooltip.helpers";
import type { RatingsSectionProps, RatingsData } from "./types";
import VoteBreakdownTooltip from "./tooltips/VoteBreakdownTooltip";
import DropVoteProgressing from "@/components/drops/view/utils/DropVoteProgressing";
import ApprovalDropVoteSummary from "@/components/waves/drops/ApprovalDropVoteSummary";
import { WAVE_VOTE_STATS_LABELS, WAVE_VOTING_LABELS } from "@/helpers/waves/waves.constants";
interface ParticipationDropRatingsTotalSectionProps extends RatingsSectionProps {
  readonly ratingsData: RatingsData;
  readonly winningThreshold?: number | null | undefined;
  readonly winningThresholdMinDurationMs?: number | null | undefined;
  readonly isVotingClosed?: boolean | undefined;
}
export default function ParticipationDropRatingsTotalSection(t0) {
  const $ = _c(30);
  const {
    drop,
    ratingsData,
    winningThreshold,
    winningThresholdMinDurationMs,
    isVotingClosed: t1
  } = t0;
  const isVotingClosed = t1 === undefined ? false : t1;
  const {
    currentRating
  } = ratingsData;
  const displayWinningThreshold = typeof winningThreshold === "number" && Number.isFinite(winningThreshold) && winningThreshold > 0 ? winningThreshold : null;
  const hasWinningThreshold = displayWinningThreshold !== null;
  if (hasWinningThreshold) {
    let t2;
    if ($[0] !== displayWinningThreshold || $[1] !== drop || $[2] !== isVotingClosed || $[3] !== winningThresholdMinDurationMs) {
      t2 = <ApprovalDropVoteSummary drop={drop} winningThreshold={displayWinningThreshold} winningThresholdMinDurationMs={winningThresholdMinDurationMs} isVotingClosed={isVotingClosed} variant="chat" showVoters={false} showUserVote={false} />;
      $[0] = displayWinningThreshold;
      $[1] = drop;
      $[2] = isVotingClosed;
      $[3] = winningThresholdMinDurationMs;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  const votingLabel = WAVE_VOTING_LABELS[drop.wave.voting_credit_type];
  const totalValueClass = currentRating < 0 ? "tw-text-rose-400" : "tw-text-iron-50";
  const t2 = `tw-font-medium ${totalValueClass}`;
  const t3 = currentRating < 0 && "-";
  let t4;
  if ($[5] !== currentRating) {
    t4 = formatNumberWithCommas(Math.abs(currentRating));
    $[5] = currentRating;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = <span className={t2}>{t3}{t4}</span>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== currentRating || $[12] !== drop.rating_prediction) {
    t6 = <DropVoteProgressing current={currentRating} projected={drop.rating_prediction} compact={true} />;
    $[11] = currentRating;
    $[12] = drop.rating_prediction;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <div className="tw-relative tw-inline-flex tw-items-center tw-gap-x-1.5">{t5}{t6}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const t8 = `total-rating-${drop.id}`;
  let t9;
  if ($[17] !== t8 || $[18] !== votingLabel) {
    t9 = <span className="tw-cursor-help tw-whitespace-nowrap tw-font-normal tw-text-iron-400" data-tooltip-id={t8}>{votingLabel} {WAVE_VOTE_STATS_LABELS.TOTAL}</span>;
    $[17] = t8;
    $[18] = votingLabel;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = `total-rating-${drop.id}`;
  let t11;
  if ($[20] !== drop || $[21] !== ratingsData) {
    t11 = <VoteBreakdownTooltip drop={drop} ratingsData={ratingsData} />;
    $[20] = drop;
    $[21] = ratingsData;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11) {
    t12 = <Tooltip id={t10} place="top" offset={8} opacity={1} positionStrategy="fixed" style={TOOLTIP_STYLES}>{t11}</Tooltip>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t7 || $[28] !== t9) {
    t13 = <div className="tw-flex tw-items-center tw-gap-x-2 tw-text-sm tw-leading-5">{t7}{t9}{t12}</div>;
    $[26] = t12;
    $[27] = t7;
    $[28] = t9;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
}